/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ApprovalError =
  | 'UNKNOWN'
  | 'GATED'
  | 'INVALID_REQUEST'
  | 'NOT_FOUND'
  | 'APPROVAL_ALREADY_EXISTS'
  | 'TRANSITION_NOT_PERMITTED'
  | 'NOT_AUTHORIZED'
  | 'APPROVER_INVALID'
  | 'APPROVALS_NOT_ENABLED'
  | 'APPROVAL_TEMPLATE_CHANGED'
  | 'TOO_MANY_REQUESTS'
  | unhandledEnumCase;

export type Actor = { actorType: ActorType; id: string };

export type ActorType = 'USER' | 'AGENT' | 'TEAM' | unhandledEnumCase;

export type ApprovalDelegate = { owner: Actor; delegate: Actor };

export type ApprovalAction =
  | 'PUBLISH'
  | 'MOVE_STAGE'
  | 'INSTALL'
  | 'EXECUTE'
  | unhandledEnumCase;

export type ApprovalRules =
  | 'NON_SEQUENTIAL'
  | 'ANY_CAN_APPROVE'
  | 'SEQUENTIAL'
  | unhandledEnumCase;

export type DelegationOption = 'DISABLED' | 'ENABLED' | unhandledEnumCase;

export type SkipApprovalOption =
  | 'NO_ONE_CAN_SKIP_APPROVAL'
  | 'EVERYONE_CAN_SKIP_APPROVAL'
  | 'SPECIFIC_LIST_CAN_SKIP_APPROVAL'
  | unhandledEnumCase;

export type ApprovalChirpError = {
  errorType: ApprovalError;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DeleteApprovalDelegateRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  owner: Actor;
};

export type DeleteApprovalTemplateRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type GetApprovalConfigurationRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type GetApprovalDelegatesRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type GetApprovalDelegationOptionRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type GetApproversRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type GetAvailableApproversForActorTypeRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  actorType: ActorType;
};

export type GetAvailableApproversRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type ListApproverCandidatesRequest = { actorType?: ActorType };

export type PutApprovalConfigurationRequest = {
  enabled: boolean;
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  skipApprovalOption?: SkipApprovalOption;
  usersIdsListThatCanSkipApproval: Default<number[]>;
};

export type PutApprovalDelegateRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  owner: Actor;
  delegate: Actor;
};

export type PutApprovalDelegationOptionRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  delegationOption: DelegationOption;
};

export type PutApprovalTemplateRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  approvalTemplate: ApprovalTemplatePayload;
};

export type PutAvailableApproversForActorTypeRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  actorType: ActorType;
  approvers: Default<Actor[]>;
};

export type PutAvailableApproversRequest = {
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  approvers: Default<Actor[]>;
};

export type SendRequestToEnableApprovalsRequest = {
  adminToNotifyUserId: number;
  message?: string;
  approvalTypeId: string;
  approvalAction: ApprovalAction;
};

export type ApprovalConfigurationResponse = {
  portalId: number;
  enabled: boolean;
  approvalTypeId: string;
  approvalAction: ApprovalAction;
  approvalConfigured: boolean;
  skipApprovalOption?: SkipApprovalOption;
  usersIdsListThatCanSkipApproval: Default<number[]>;
  approvalTemplate?: ApprovalTemplateResponse;
};

export type ApproverCandidate = {
  actor: Actor;
  displayName: string;
  description?: string;
  iconUrl?: string;
};

export type DeleteApprovalDelegateResponse = { deleted: boolean };

export type DeleteApprovalTemplateResponse = {};

export type GetApprovalConfigurationResponse = {
  approvalConfiguration: ApprovalConfigurationResponse;
};

export type GetApprovalDelegatesResponse = {
  delegates: Default<ApprovalDelegate[]>;
};

export type GetApprovalDelegationOptionResponse = {
  delegationOption: DelegationOption;
};

export type GetApproversResponse = { approvers: Default<Actor[]> };

export type GetAvailableApproversForActorTypeResponse = {
  approvers: Default<Actor[]>;
};

export type GetAvailableApproversResponse = { approvers: Default<Actor[]> };

export type ListApproverCandidatesResponse = {
  candidates: Default<ApproverCandidate[]>;
};

export type PutApprovalConfigurationResponse = {
  approvalConfiguration: ApprovalConfigurationResponse;
};

export type PutApprovalDelegateResponse = { delegate: ApprovalDelegate };

export type PutApprovalDelegationOptionResponse = {
  delegationOption: DelegationOption;
};

export type PutApprovalTemplateResponse = {
  approvalTemplate: ApprovalTemplateResponse;
};

export type PutAvailableApproversForActorTypeResponse = {
  approvers: Default<Actor[]>;
};

export type PutAvailableApproversResponse = { approvers: Default<Actor[]> };

export type SendRequestToEnableApprovalsResponse = { idempotencyId?: string };

export type ApprovalTemplateDueDateRulePayload = {
  offset: number;
  /** @deprecated Due-date locks are no longer supported. */
  locked: Default<boolean>;
};

export type ApprovalTemplateDueDateRuleResponse = {
  offset: number;
  /** @deprecated Due-date locks are no longer supported. */
  locked: Default<boolean>;
};

export type ApprovalTemplateNotePayload = {
  value: string;
  /** @deprecated Requester-note locks are no longer supported. */
  locked: Default<boolean>;
};

export type ApprovalTemplateNoteResponse = {
  value: string;
  /** @deprecated Requester-note locks are no longer supported. */
  locked: Default<boolean>;
};

export type ApprovalTemplatePayload = {
  approvalRule?: ApprovalTemplateRulePayload;
  approvalSteps: Default<ApprovalTemplateStepPayload[]>;
  approvalStepListLocked: boolean;
  dueDateRule?: ApprovalTemplateDueDateRulePayload;
  requesterNote?: ApprovalTemplateNotePayload;
};

export type ApprovalTemplateResponse = {
  approvalRule?: ApprovalTemplateRuleResponse;
  approvalSteps: Default<ApprovalTemplateStepResponse[]>;
  approvalStepListLocked: boolean;
  dueDateRule?: ApprovalTemplateDueDateRuleResponse;
  requesterNote?: ApprovalTemplateNoteResponse;
};

export type ApprovalTemplateRulePayload = {
  value: ApprovalRules;
  locked: boolean;
};

export type ApprovalTemplateRuleResponse = {
  value: ApprovalRules;
  locked: boolean;
};

export type ApprovalTemplateStepPayload = {
  actor: Actor;
  order?: number;
  locked: boolean;
  stageLocked: Default<boolean>;
};

export type ApprovalTemplateStepResponse = {
  actor: Actor;
  order?: number;
  locked: boolean;
  stageLocked: Default<boolean>;
};

export type GetApprovalConfigurationRequestType =
  Requestify<GetApprovalConfigurationRequest>;
export type GetApprovalConfigurationResponseType =
  GetApprovalConfigurationResponse;
export type GetApprovalConfigurationErrorType = ApprovalChirpError &
  HubspotMetadata;
export const getApprovalConfigurationRpc: ChirpAvroRpcDetails<
  GetApprovalConfigurationRequestType,
  GetApprovalConfigurationResponseType,
  GetApprovalConfigurationErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalConfiguration',
  auth: 'app',
  fingerprint: '35lRVF4BpRFxfdT4gIOpm4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApproversRequestType = Requestify<GetApproversRequest>;
export type GetApproversResponseType = GetApproversResponse;
export type GetApproversErrorType = ApprovalChirpError & HubspotMetadata;
export const getApproversRpc: ChirpAvroRpcDetails<
  GetApproversRequestType,
  GetApproversResponseType,
  GetApproversErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovers',
  auth: 'app',
  fingerprint: 'Eh2sXrQKQPuv1wchydvePIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutApprovalConfigurationRequestType =
  Requestify<PutApprovalConfigurationRequest>;
export type PutApprovalConfigurationResponseType =
  PutApprovalConfigurationResponse;
export type PutApprovalConfigurationErrorType = ApprovalChirpError &
  HubspotMetadata;
export const putApprovalConfigurationRpc: ChirpAvroRpcDetails<
  PutApprovalConfigurationRequestType,
  PutApprovalConfigurationResponseType,
  PutApprovalConfigurationErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalConfiguration',
  auth: 'app',
  fingerprint: 'dIXjR88WPQ9zV72px2ReRYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SendRequestToEnableApprovalsRequestType =
  Requestify<SendRequestToEnableApprovalsRequest>;
export type SendRequestToEnableApprovalsResponseType =
  SendRequestToEnableApprovalsResponse;
export type SendRequestToEnableApprovalsErrorType = ApprovalChirpError &
  HubspotMetadata;
export const sendRequestToEnableApprovalsRpc: ChirpAvroRpcDetails<
  SendRequestToEnableApprovalsRequestType,
  SendRequestToEnableApprovalsResponseType,
  SendRequestToEnableApprovalsErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'sendRequestToEnableApprovals',
  auth: 'app',
  fingerprint: 'Jl5Rz9UpL-e_GCjzXfbQCYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListApproverCandidatesRequestType =
  Requestify<ListApproverCandidatesRequest>;
export type ListApproverCandidatesResponseType = ListApproverCandidatesResponse;
export type ListApproverCandidatesErrorType = ApprovalChirpError &
  HubspotMetadata;
export const listApproverCandidatesRpc: ChirpAvroRpcDetails<
  ListApproverCandidatesRequestType,
  ListApproverCandidatesResponseType,
  ListApproverCandidatesErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'listApproverCandidates',
  auth: 'app',
  fingerprint: '8x4o4ygqZnUp1MG7i1N6koT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAvailableApproversRequestType =
  Requestify<GetAvailableApproversRequest>;
export type GetAvailableApproversResponseType = GetAvailableApproversResponse;
export type GetAvailableApproversErrorType = ApprovalChirpError &
  HubspotMetadata;
export const getAvailableApproversRpc: ChirpAvroRpcDetails<
  GetAvailableApproversRequestType,
  GetAvailableApproversResponseType,
  GetAvailableApproversErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getAvailableApprovers',
  auth: 'app',
  fingerprint: 'BiOOTe1f9WnzUWtu9RuTXYT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutAvailableApproversRequestType =
  Requestify<PutAvailableApproversRequest>;
export type PutAvailableApproversResponseType = PutAvailableApproversResponse;
export type PutAvailableApproversErrorType = ApprovalChirpError &
  HubspotMetadata;
export const putAvailableApproversRpc: ChirpAvroRpcDetails<
  PutAvailableApproversRequestType,
  PutAvailableApproversResponseType,
  PutAvailableApproversErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putAvailableApprovers',
  auth: 'app',
  fingerprint: 'WGb6dlmzoadpR8Bo9-fas4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAvailableApproversForActorTypeRequestType =
  Requestify<GetAvailableApproversForActorTypeRequest>;
export type GetAvailableApproversForActorTypeResponseType =
  GetAvailableApproversForActorTypeResponse;
export type GetAvailableApproversForActorTypeErrorType = ApprovalChirpError &
  HubspotMetadata;
export const getAvailableApproversForActorTypeRpc: ChirpAvroRpcDetails<
  GetAvailableApproversForActorTypeRequestType,
  GetAvailableApproversForActorTypeResponseType,
  GetAvailableApproversForActorTypeErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getAvailableApproversForActorType',
  auth: 'app',
  fingerprint: 'V38uP37SAiM6Bonhv9q7dIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutAvailableApproversForActorTypeRequestType =
  Requestify<PutAvailableApproversForActorTypeRequest>;
export type PutAvailableApproversForActorTypeResponseType =
  PutAvailableApproversForActorTypeResponse;
export type PutAvailableApproversForActorTypeErrorType = ApprovalChirpError &
  HubspotMetadata;
export const putAvailableApproversForActorTypeRpc: ChirpAvroRpcDetails<
  PutAvailableApproversForActorTypeRequestType,
  PutAvailableApproversForActorTypeResponseType,
  PutAvailableApproversForActorTypeErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putAvailableApproversForActorType',
  auth: 'app',
  fingerprint: 'olD8f-kK33ay30tGIeYmhIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutApprovalTemplateRequestType =
  Requestify<PutApprovalTemplateRequest>;
export type PutApprovalTemplateResponseType = PutApprovalTemplateResponse;
export type PutApprovalTemplateErrorType = ApprovalChirpError & HubspotMetadata;
export const putApprovalTemplateRpc: ChirpAvroRpcDetails<
  PutApprovalTemplateRequestType,
  PutApprovalTemplateResponseType,
  PutApprovalTemplateErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalTemplate',
  auth: 'app',
  fingerprint: 'JsYt8iwC64Ku-0_lgUJJQ4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteApprovalTemplateRequestType =
  Requestify<DeleteApprovalTemplateRequest>;
export type DeleteApprovalTemplateResponseType = DeleteApprovalTemplateResponse;
export type DeleteApprovalTemplateErrorType = ApprovalChirpError &
  HubspotMetadata;
export const deleteApprovalTemplateRpc: ChirpAvroRpcDetails<
  DeleteApprovalTemplateRequestType,
  DeleteApprovalTemplateResponseType,
  DeleteApprovalTemplateErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'deleteApprovalTemplate',
  auth: 'app',
  fingerprint: '6UuSzsLuvMGW_l6eC_Xmc4T0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApprovalDelegatesRequestType =
  Requestify<GetApprovalDelegatesRequest>;
export type GetApprovalDelegatesResponseType = GetApprovalDelegatesResponse;
export type GetApprovalDelegatesErrorType = ApprovalChirpError &
  HubspotMetadata;
export const getApprovalDelegatesRpc: ChirpAvroRpcDetails<
  GetApprovalDelegatesRequestType,
  GetApprovalDelegatesResponseType,
  GetApprovalDelegatesErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalDelegates',
  auth: 'app',
  fingerprint: 'HDE4bSkXk9wZTdM-chU-sIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutApprovalDelegateRequestType =
  Requestify<PutApprovalDelegateRequest>;
export type PutApprovalDelegateResponseType = PutApprovalDelegateResponse;
export type PutApprovalDelegateErrorType = ApprovalChirpError & HubspotMetadata;
export const putApprovalDelegateRpc: ChirpAvroRpcDetails<
  PutApprovalDelegateRequestType,
  PutApprovalDelegateResponseType,
  PutApprovalDelegateErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalDelegate',
  auth: 'app',
  fingerprint: 'FiI4-8FeIRLk2yu0QVUjzIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteApprovalDelegateRequestType =
  Requestify<DeleteApprovalDelegateRequest>;
export type DeleteApprovalDelegateResponseType = DeleteApprovalDelegateResponse;
export type DeleteApprovalDelegateErrorType = ApprovalChirpError &
  HubspotMetadata;
export const deleteApprovalDelegateRpc: ChirpAvroRpcDetails<
  DeleteApprovalDelegateRequestType,
  DeleteApprovalDelegateResponseType,
  DeleteApprovalDelegateErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'deleteApprovalDelegate',
  auth: 'app',
  fingerprint: 'cgZ6emK5H82-kPcJg72bvIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetApprovalDelegationOptionRequestType =
  Requestify<GetApprovalDelegationOptionRequest>;
export type GetApprovalDelegationOptionResponseType =
  GetApprovalDelegationOptionResponse;
export type GetApprovalDelegationOptionErrorType = ApprovalChirpError &
  HubspotMetadata;
export const getApprovalDelegationOptionRpc: ChirpAvroRpcDetails<
  GetApprovalDelegationOptionRequestType,
  GetApprovalDelegationOptionResponseType,
  GetApprovalDelegationOptionErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'getApprovalDelegationOption',
  auth: 'app',
  fingerprint: '5ZtouO6HMTvHDpGusNL5DIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PutApprovalDelegationOptionRequestType =
  Requestify<PutApprovalDelegationOptionRequest>;
export type PutApprovalDelegationOptionResponseType =
  PutApprovalDelegationOptionResponse;
export type PutApprovalDelegationOptionErrorType = ApprovalChirpError &
  HubspotMetadata;
export const putApprovalDelegationOptionRpc: ChirpAvroRpcDetails<
  PutApprovalDelegationOptionRequestType,
  PutApprovalDelegationOptionResponseType,
  PutApprovalDelegationOptionErrorType,
  false
> = {
  serviceName: 'com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc',
  rpcName: 'putApprovalDelegationOption',
  auth: 'app',
  fingerprint: 'SgXfpwTwNwbLwaysGxOaqIT0rjFl7MXr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
